export default "<div class=\"dashboard\">\n    <app-counts></app-counts>\n    <app-projectlist></app-projectlist>\n</div>\n"